import React, { useEffect, useRef } from 'react';
import LinkTable from '@/creditflowresearch/ui/common/components/LinkTable';
import { useLeagueTableContext } from '@/creditflowresearch/application/League/Table/LeagueTableContext';

const UnderwritersTable = (props) => {
  const didMount = useRef(false);
  const {
    state,
    paginateUnderwriters,
    itemsPerPageUnderwriters,
    getUnderwritersByFilter,
  } = useLeagueTableContext();
  const { page, perPage } = state.underwritersCollection;

  const onPageChange = (page) => {
    paginateUnderwriters(page.selected);
  };

  const onItemsPerPageChange = (perPage) => {
    itemsPerPageUnderwriters(perPage.value);
  };

  useEffect(() => {
    if (didMount.current) {
      getUnderwritersByFilter();
    } else {
      didMount.current = true;
    }
  }, [page, perPage]);

  return (
    <LinkTable
      { ...props }
      { ...state.underwritersCollection }
      onPageChange={ onPageChange }
      onItemsPerPageChange={ onItemsPerPageChange }
    />
  );
};

export default UnderwritersTable;
